import { render } from "./EditionDonnees.vue?vue&type=template&id=7c641582"
import script from "./EditionDonnees.vue?vue&type=script&lang=js"
export * from "./EditionDonnees.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__